import { ServiceSettingsOffersPageStore } from './service-settings-offers-page.store';
import { fb, routeParams, translate } from '../../../../modules/shared/shared.global-service';
import { Component, computed, inject, viewChild } from '@angular/core';
import { getSocialServiceOffersFrag } from './service-settings-offers-page.query';
import {
    SocialServiceOfferObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-offer.object';
import { ConfirmBuilder } from '../../../../modules/shared/service/confirm.builder';
import { contentGlobalSuccess } from '../../../../modules/content/content.error';
import { TableComponent } from '../../../../modules/shared/components/kit/table/table.component';
import { ActivatedRoute, Router } from '@angular/router';
import {
    boolColumn,
    colorColumn,
    dateField,
    nameColumn,
    textColumn,
} from '../../../../modules/shared/components/kit/table/table.fields';
import { measurementUnitEnumOptions } from '@libs/types/src/common/enum/measurement-unit.enum';
import { TableColumn } from '../../../../modules/shared/components/kit/table/table.types';
import { SelectButtonComponent } from '../../../kit/select-button/select-button.component';
import { TranslatePipe } from '@ngx-translate/core';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { changeSignal } from '../../../../utils/form.utils';
import { CardTableComponent } from '../../../../modules/shared/components/kit/table/card-table.component';
import { FormatOfferUnitPricePipe } from '../../../../modules/shared/pipes/format-service-offer-unit-price.pipe';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-service-settings-offers-page',
    templateUrl: './service-settings-offers-page.component.html',
    styleUrl: './service-settings-offers-page.component.scss',
    providers: [ServiceSettingsOffersPageStore],
    imports: [
        SelectButtonComponent,
        TranslatePipe,
        CardTableComponent,
        FormatOfferUnitPricePipe,
        PrimeTemplate,
    ],
})
export class ServiceSettingsOffersPageComponent {

    public readonly store = inject(ServiceSettingsOffersPageStore);
    public readonly confirm = inject(ConfirmBuilder);
    public readonly router = inject(Router);
    public readonly route = inject(ActivatedRoute);

    protected readonly offerTable = viewChild<TableComponent>('offerTable');

    protected form = fb.group({
        active: fb.control<string>('true'),
    });

    protected prefix = 'service.offer.';
    protected activeChange = changeSignal(this.form.controls.active);
    protected additionalFilter = computed(() => {
        const filter = new FilterBuilder();
        filter.serviceId(routeParams.serviceId());
        if (this.activeChange() === 'true') {
            filter.validByNow();
        } else {
            const now = new Date();
            filter.date(now, 'validTo', 'LTE', false);
            filter.orWhere('validFrom', now.toISOString(), 'GTE');
        }

        return filter.filter().filter;
    });

    protected columns: TableColumn[] = [
        colorColumn,
        textColumn('code'),
        nameColumn,
        {
            name: 'unit',
            sortable: true,
            filterable: {
                type: 'select',
                selectOptions: () => measurementUnitEnumOptions,
            },
            data: (item: any) => item ? translate.instant(`enum.measurementUnit.${item}`) : '',
        },
        boolColumn('payment'),
        textColumn('unitPrice'),
        textColumn('unitPriceExt'),
        dateField('validFrom'),
        dateField('validTo'),
    ];

    protected readonly getSocialServiceOffersFrag = getSocialServiceOffersFrag;

    protected async upsertOffer(item: SocialServiceOfferObject | null = null): Promise<void> {
        const id = item?.id || 'create';
        await this.router.navigate([id], { relativeTo: this.route });
    }

    protected async deleteOffer(event: any): Promise<void> {
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteSocialServiceOffer({ id: event.item.id });
                contentGlobalSuccess.next('common.deleted');
                this.offerTable()?.reload();
            },
            event,
        );
    }

    protected readonly fb = fb;
    protected readonly routeParams = routeParams;
}
